import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Input from '../input';
import Popup from './';

class FeedbackPopup extends Component {
  static propTypes = {
    // route: PropTypes.string.isRequired,
    filmId: PropTypes.number,
    orderId: PropTypes.number,
  };

  state = {
    sendData: false,
    error: null,
    success: false,
    type: this.props.type,
    data: null,
    filmId: this.props.filmId,
    orderId: this.props.orderId,
    filmRating: this.props.filmRating,
    cinemaRating: this.props.cinemaRating,
    filmText: this.props.filmText,
    cinemaText: this.props.cinemaText,
    isEdit: false,
  };

  componentWillMount() {
    if (!this.state.cinemaText) {
      this.setState({
        isEdit: true,
      });
    }
  }

  componentWillUnmount() {
    const { type } = this.state;
    type === 'feedback' ? location.reload() : null;
    this;
  }

  fetchPostComment = (url, headers) => {
    this.setState({
      sendData: true,
      error: null,
    });

    fetch(url, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          this.setState({
            sendData: false,
            error: null,
            success: true,
          });
        } else {
          this.setState({
            sendData: false,
            error: json.errors.message,
          });
          console.error(json);
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({
          sendData: false,
          error: null,
        });
      });
  };

  confirm = e => {
    e.preventDefault();
    const {
      filmRating,
      filmText,
      filmId,
      cinemaText,
      cinemaRating,
      orderId,
    } = this.state;

    if (cinemaRating === '' || filmRating === '') {
      this.setState({
        error: <span className="error">Не выбраны оценки</span>,
      });
      return;
    }

    if (cinemaText.length < 25 || filmText.length < 25) {
      this.setState({
        error: (
          <span className="error">
            Комментарий должен быть больше 25 символов
          </span>
        ),
      });
      return;
    }

    // Create Oreder Comment
    // const createOrderCommentUrl =
    //   'https://smr.megawiki.ru/local/php_interface/api/v1/user/review/cinema/create_order_comment.php';
    const createOrderCommentUrl =
      '/local/php_interface/api/v1/user/review/cinema/create_order_comment.php';

    const createOrderData = {
      body: cinemaText,
      rate: cinemaRating,
      'order-id': orderId,
    };

    const createOrderCommentHeaders = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(createOrderData),
    };

    //Create Review
    // const createReviewUrl =
    //   'https://smr.megawiki.ru/local/php_interface/api/v1/user/review/film/create_review.php';
    const createReviewUrl =
      '/local/php_interface/api/v1/user/review/film/create_review.php';

    const createReviewCommentformData = new FormData();

    createReviewCommentformData.append('body', filmText);
    createReviewCommentformData.append('rate', filmRating);
    createReviewCommentformData.append('film-id', filmId);

    const createReviewHeaders = {
      method: 'POST',
      headers: {},
      body: createReviewCommentformData,
    };

    this.fetchPostComment(createOrderCommentUrl, createOrderCommentHeaders);

    if (this.state.isEdit) {
      this.fetchPostComment(createReviewUrl, createReviewHeaders);
    }
  };

  chooseEmoji = e => {
    e.preventDefault();

    const rating = $(e.target).data('rating');

    $(e.target)
      .parent()
      .attr('data-rating', rating);

    if (
      $(e.target)
        .parent()
        .hasClass('emoji-rating__film')
    ) {
      this.setState({
        filmRating: rating,
      });
    }

    if (
      $(e.target)
        .parent()
        .hasClass('emoji-rating__cinema')
    ) {
      this.setState({
        cinemaRating: rating,
      });
    }
  };

  render() {
    const {
      sendData,
      error,
      success,
      type,
      filmRating,
      filmText,
      cinemaRating,
      cinemaText,
      isEdit,
    } = this.state;

    if (success)
      return (
        <Popup
          type="alert"
          status="success"
          title="Отлично!"
          message="Ваше сообщение отправлено. Спасибо за отзыв!"
          button="Назад"
        />
      );

    let btnClasses = ['btn'];

    if (sendData) btnClasses.push('btn--loading');

    return (
      <div className="popup feedback-popup">
        <form className="popup__content">
          <div className="popup__content-inner">
            <div className="popup__section-title">
              <h3 className="heading heading--1 popup__title">Ваши оценки</h3>
            </div>
            <div className="inp-group">
              <div className="row">
                <div className="inp-group__case">
                  <p className="popup__subtitle">Как вам фильм?</p>
                  <div
                    className="emoji-rating emoji-rating__film"
                    data-rating={filmRating}
                  >
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="1"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-poop.svg)',
                      }}
                      onClick={type === 'feedback' ? this.chooseEmoji : null}
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="2"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-angry.svg)',
                      }}
                      onClick={type === 'feedback' ? this.chooseEmoji : null}
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="3"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-pokerface.svg)',
                      }}
                      onClick={type === 'feedback' ? this.chooseEmoji : null}
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="4"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-laugh.svg)',
                      }}
                      onClick={type === 'feedback' ? this.chooseEmoji : null}
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="5"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-love.svg)',
                      }}
                      onClick={type === 'feedback' ? this.chooseEmoji : null}
                    ></a>
                  </div>
                  {type === 'feedback' ? (
                    <Input
                      label="Комментарий"
                      textarea
                      placeholder="Напишите, что понравилось или не понравилось"
                      onChange={e =>
                        this.setState({
                          filmText: e,
                        })
                      }
                      value={filmText}
                    />
                  ) : (
                    <p className="popup__txt">{this.state.filmText}</p>
                  )}
                </div>
                <div className="inp-group__case">
                  <p className="popup__subtitle">Понравился наш кинотеатр?</p>
                  <div
                    className="emoji-rating emoji-rating__cinema"
                    data-rating={cinemaRating}
                  >
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="1"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-poop.svg)',
                      }}
                      onClick={
                        type === 'feedback' || isEdit ? this.chooseEmoji : null
                      }
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="2"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-angry.svg)',
                      }}
                      onClick={
                        type === 'feedback' || isEdit ? this.chooseEmoji : null
                      }
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="3"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-pokerface.svg)',
                      }}
                      onClick={
                        type === 'feedback' || isEdit ? this.chooseEmoji : null
                      }
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="4"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-laugh.svg)',
                      }}
                      onClick={
                        type === 'feedback' || isEdit ? this.chooseEmoji : null
                      }
                    ></a>
                    <a
                      className="emoji-rating__item"
                      href="#"
                      data-rating="5"
                      style={{
                        backgroundImage:
                          'url(/local/templates/comfortkino/static/img/emoji/emoji-love.svg)',
                      }}
                      onClick={
                        type === 'feedback' || isEdit ? this.chooseEmoji : null
                      }
                    ></a>
                  </div>
                  {isEdit ? (
                    <Input
                      label="Комментарий"
                      textarea
                      placeholder="Напишите, что понравилось или не понравилось"
                      onChange={e =>
                        this.setState({
                          cinemaText: e,
                        })
                      }
                      value={cinemaText}
                    />
                  ) : (
                    <p className="popup__txt">{cinemaText}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="popup__btn-wrap">
              {error ? <p>{error}</p> : null}
              <div className="wrap">
                {type === 'feedback' || isEdit ? (
                  <button
                    className={btnClasses.join(' ')}
                    onClick={this.confirm}
                  >
                    Оценить
                  </button>
                ) : (
                  <a
                    className="btn"
                    onClick={() =>
                      this.setState({
                        type: 'feedback',
                      })
                    }
                  >
                    Редактировать
                  </a>
                )}
              </div>
            </div>
          </div>
        </form>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
          </svg>
        </button>
      </div>
    );
  }
}

export default FeedbackPopup;
